export const endpoint = 'image'